import React, {
  useEffect,
  useCallback,
  useContext,
  useState,
  useRef,
} from 'react';
import styled from 'styled-components';
import QuotationForm from '../PdfForms/QuotationForm';
import {Context} from '../AppContext';
import {pdf} from '@react-pdf/renderer';
import {message} from 'antd';
import {saveAs} from 'file-saver';
const config = require('../data.json');

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default function QuotationDownload(props) {
  const {order} = props;
  const spec = useRef();
  const orderItems = useRef([]);
  const app = useContext(Context);

  const [cart] = useState(() => {
    if (order) {
      try {
        return JSON.parse(order.cart);
      } catch {}
    }
    return app.state.cart;
  });

  const getSpec = useCallback(async () => {
    try {
      let resp = await app.actions.getSpec(cart.version);
      spec.current = resp;
    } catch (err) {}
  }, []);

  const getOrderItems = useCallback(async () => {
    try {
      let resp = await app.actions.getOrderItems({
        order: order.id,
      });
      orderItems.current = resp;
    } catch (err) {}
  }, [order]);

  const generate = useCallback(async () => {
    app.actions.setLoading(true);
    await Promise.all([getSpec(), getOrderItems()]);

    if (!spec.current) {
      return message.error('無法取得商品規格!');
    }
    const blob = await pdf(
      <QuotationForm
        order={order}
        spec={spec.current}
        orderItems={orderItems.current}
      />,
    ).toBlob();
    app.actions.setLoading(false);

    saveAs(blob, '估價單.pdf');
  }, [app.actions, spec, order]);

  const editDownloaded = useCallback(async () => {
    try {
      //標示為已下載估價單
      app.actions.editOrderDownloaded({
        id: order.id,
        downloaded: true,
      });
    } catch (err) {
      console.warn(err);
    }
  }, []);

  if (!order) {
    return null;
  }

  return (
    <>
      <Button
        onClick={(e) => {
          editDownloaded();
          generate();
        }}>
        下載估價單
      </Button>
    </>
  );
}

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: white;
  color: ${config.colors.text};
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  font-size: 13px;
  padding: 8px 0;
  box-shadow: 0 2px 5px -2px #999;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover {
    opacity: 0.75;
  }

  ${(props) => props.css}
`;
